const STORAGE_KEY = 'otw.lastActivityAt'
const DEFAULT_IDLE_MS = 60 * 60 * 1000
const DEBUG_IDLE_KEY = 'otw.debugIdleMs'

let lastActivityAt: number | undefined

const readStored = (): number | undefined => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return undefined
    }
    const n = Number(raw)
    return Number.isFinite(n) ? n : undefined
  } catch {
    return undefined
  }
}

export function getLastActivityTimestamp(): number | undefined {
  if (lastActivityAt !== undefined) {
    return lastActivityAt
  }
  lastActivityAt = readStored()
  return lastActivityAt
}

export function setLastActivityTimestamp(ts: number): void {
  lastActivityAt = ts
  try {
    sessionStorage.setItem(STORAGE_KEY, String(ts))
  } catch {
    // private mode
  }
}

export function clearLastActivityTimestamp(): void {
  lastActivityAt = undefined
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // private mode
  }
}

export function getIdleTimeoutMs(): number {
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    try {
      const debug = sessionStorage.getItem(DEBUG_IDLE_KEY)
      const n = debug ? Number(debug) : NaN
      if (Number.isFinite(n) && n >= 5000) {
        return n
      }
    } catch {
      // private mode
    }
  }
  return DEFAULT_IDLE_MS
}

export function isIdleExpired(now = Date.now()): boolean {
  const last = getLastActivityTimestamp()
  if (last === undefined) {
    return false
  }
  return now - last >= getIdleTimeoutMs()
}
